import CharaChange from "./charachange.es6";
import ScrollFunc from "./scrollfunc.es6";
import Loader from "./loader.es6";
import Bnr from "./bnr.es6";
export default class Top {
    constructor() {
        this.CharaChange = new CharaChange();
        this.ScrollFunc = new ScrollFunc();
        this.Loader = new Loader();
        this.Bnr = new Bnr();
        this.init();
    }

    init() {
        this.setScroller();
    }

    setScroller() {
        const mv = document.querySelector(".mainvisual");
        const fxdelm = [...document.querySelectorAll(".js-fxdelm")];

        const setClass = () => {
            if (mv.offsetHeight > window.innerHeight) {
                fxdelm.forEach((el) => el.classList.add("-fixed"));
            } else {
                fxdelm.forEach((el) => el.classList.remove("-fixed"));
            }
        };

        window.addEventListener("resize", setClass);
        setClass();
    }
}
